/**************************************************************************************************/
/*   File: /src/app/shared/models/dossier.ts                                                      */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Apr 19 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { DossierSummary } from './dossier.summary';
import { LocalDocument } from './local.document';
import { SpatialData } from './spatial.data';
import { TerritorialAreaRegulations } from './territorial.area.regulations';

/**
 * The dossier object
 */
export class Dossier {
    /**
     * The dossier summary
     */
    summary: DossierSummary;
    /**
     * Other files uploaded
     */
    other?: LocalDocument;
    /**
     * The spatial data
     */
    spatialData?: SpatialData;
    /**
     * The spatial data report
     */
    spatialDataReport?: SpatialData;
    /**
     * The informative report
     */
    spatialInformativeReport?: LocalDocument;
    /**
     * Territorial areas regulations map
     */
    territorialAreasRegulations?: { [key: string]: TerritorialAreaRegulations };

    polygonList: { extent: string }

}
